import React from "react";

function Appartementsvg() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="30"
      height="30"
      fill="none"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.5"
      className="icon icon-tabler icon-tabler-bed"
      viewBox="0 0 24 24"
    >
      <path stroke="none" d="M0 0h24v24H0z"></path>
      <path d="M3 7v11m0-4h18m0 4v-8a2 2 0 00-2-2h-8v6"></path>
      <circle cx="7" cy="10" r="1"></circle>
    </svg>
  );
}

export default Appartementsvg;
